/**
 * Times out for specified time and returns promise.
 */
export const sleep = (timeoutMs: number): Promise<void> => {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, timeoutMs);
  });
};

/**
 * Check whether the word is blank.
 */
export function isBlank(word: string | null | undefined) {
  return !word || word.trim().length === 0;
}
